import { useState } from 'react';
import { Printer } from 'lucide-react';
import { Button, useToast } from '@eombor/ui';
import { printBlob } from '../../../shared/api/print.js';
import { t } from '../../../shared/i18n/index.js';

/**
 * ETIKETKA — PDF serverda chiziladi (QR + kod + nom) va darhol bosmaga
 * yuboriladi: skladchi uni yuklab olib, papkadan qidirib o'tirmaydi.
 */
export const LabelPrintButton = ({
  load,
  label = t('label.print'),
  variant = 'ghost',
}: {
  load: () => Promise<Blob>;
  label?: string;
  variant?: 'ghost' | 'secondary';
}) => {
  const [busy, setBusy] = useState(false);
  const toast = useToast();

  return (
    <Button
      variant={variant}
      size="sm"
      loading={busy}
      onClick={() => {
        setBusy(true);
        load()
          .then(printBlob)
          .catch((err: unknown) => toast.show(err instanceof Error ? err.message : t('label.printFailed'), 'danger'))
          .finally(() => setBusy(false));
      }}
    >
      <Printer size={14} aria-hidden />
      {label}
    </Button>
  );
};
